import { Maskito } from './vendor/@maskito/core/index.esm';
import { maskitoDateOptionsGenerator } from './vendor/@maskito/kit/index.esm';

export default (element) => {
    let max = new Date();
    let min = new Date();

    min.setTime(min.getTime() - 3.154e+10 * 110);

    let options = maskitoDateOptionsGenerator({
        mode: 'yyyy',
        min: min,
        max: max,
    });

    return new Maskito(element, options);
}
